import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/sun-medium.vue
var o = {
	name: "DtIconSunMedium",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--sun-medium"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Sun Medium",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M4.232 4.232a2.5 2.5 0 1 1 3.536 3.536 2.5 2.5 0 0 1-3.536-3.536ZM6 4.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM6 1a.5.5 0 0 1 .5.5V2a.5.5 0 0 1-1 0v-.5A.5.5 0 0 1 6 1Zm0 8.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-1 0V10a.5.5 0 0 1 .5-.5ZM1 6a.5.5 0 0 1 .5-.5H2a.5.5 0 0 1 0 1h-.5A.5.5 0 0 1 1 6Zm8.5 0a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 0 1H10a.5.5 0 0 1-.5-.5Zm.036-3.536a.5.5 0 0 1 0 .708l-.354.353a.5.5 0 1 1-.707-.707l.353-.354a.5.5 0 0 1 .708 0ZM3.525 8.475a.5.5 0 0 1 0 .707l-.353.354a.5.5 0 1 1-.708-.708l.354-.353a.5.5 0 0 1 .707 0ZM2.464 2.464a.5.5 0 0 1 .708 0l.353.354a.5.5 0 1 1-.707.707l-.354-.353a.5.5 0 0 1 0-.708Zm6.011 6.011a.5.5 0 0 1 .707 0l.354.353a.5.5 0 1 1-.708.708l-.353-.354a.5.5 0 0 1 0-.707Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=sun-medium.js.map